import classNames from 'classnames'
import React from 'react'
import type { IconSizeType } from '../../icon'
import { IconSize } from '../../icon'
import { LoadingIndicator, LoadingIndicatorSize } from '../../loading-indicator'
import styles from './BaseButton.module.scss'
import type { BaseButtonProps, ButtonSizeType } from './types'
import { ButtonSize, ButtonVariants } from './types'

const mapperButtonIconSize: Map<ButtonSizeType, IconSizeType> = new Map([
  [ButtonSize.xsmall, IconSize.medium],
  [ButtonSize.small, IconSize.medium],
  [ButtonSize.medium, IconSize.medium],
  [ButtonSize.large, IconSize.medium],
])

const mapperTypograhy: Map<ButtonSizeType, string> = new Map([
  [ButtonSize.xsmall, 'pintxo-typography-callout3'],
  [ButtonSize.small, 'pintxo-typography-callout2'],
  [ButtonSize.medium, 'pintxo-typography-callout1'],
  [ButtonSize.large, 'pintxo-typography-callout1'],
])

const ButtonHoC: React.FC<BaseButtonProps> = ({
  className,
  label,
  size = ButtonSize.medium,
  block = false,
  loading = false,
  variant = ButtonVariants.primary,
  disabled = false,
  children,
  rtl = false,
  trailingIcon,
  leadingIcon,
  loadingIndicatorSize = LoadingIndicatorSize.medium,
  type = 'button',
  ...rest
}) => {
  const LeadingIcon = leadingIcon
  const TrailingIcon = trailingIcon

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const iconSize = mapperButtonIconSize.get(size)
  const typography = mapperTypograhy.get(size)

  return (
    <button
      className={classNames(styles['pintxo-button'], className, typography)}
      data-size={size}
      data-variant={variant}
      data-disabled={disabled}
      data-loading={loading}
      data-block={block}
      data-rtl={rtl}
      disabled={disabled}
      name={label}
      role="button"
      type={type}
      {...rest}
    >
      <span className={styles['pintxo-button__content']}>
        {LeadingIcon && <LeadingIcon rtl={rtl} outline size={iconSize} />}
        {(label || children) && (
          <span className={styles['pintxo-button__content__label']}>{label || children}</span>
        )}
        {loading ? (
          <LoadingIndicator size={loadingIndicatorSize} />
        ) : (
          TrailingIcon && <TrailingIcon rtl={rtl} outline size={iconSize} />
        )}
      </span>
    </button>
  )
}

export default ButtonHoC
